import { ModalInfoTemplateProps } from './';
import { ModalErrorTitle } from 'modules/modals/components/ModalErrorMessage';

const template: ModalInfoTemplateProps = {
  ariaLabel: 'Events Error',
  closeLabel: 'Retry',
  renderHeader: () => <ModalErrorTitle />,
};

export default template;
